import styled from "styled-components";

import { SearchAddressStyledProps as Props } from "./SearchAddress.types";
import { SearchAddressContentStyledProps } from "./SearchAddress.types";

const SearchAddressStyled = styled.div<Props>`
  display: flex;
  padding: 1.6rem;
  padding-top: 0;
  background-color: var(--palette-black-s2-l17);

  .SearchAddress {
    &__search-bar {
      width: 100%;

      .SearchBar {
        &__wrapper,
        &__btn {
          background-color: var(--palette-black-s2-l21);

          path {
            fill: var(--palette-white);
            opacity: 0.4;
          }
        }
      }
    }

    &__loading {
      height: 2rem;
      width: 2rem;
      animation: rotate 0.6s linear infinite;
    }

    &__cancel-button {
      font-size: 1.2rem;
      font-weight: 600;
    }
  }

  &&& .SearchBar__input {
    padding: 1rem 1.2rem;
    border: none;
    color: var(--palette-white);
    background-color: var(--palette-black-s2-l21);

    &:focus {
      box-shadow: none;
    }

    &:hover:not([disabled]) {
      border: none;
    }
  }
`;

export const SearchAddressContentStyled = styled.div<SearchAddressContentStyledProps>`
  position: fixed;
  width: inherit;
  max-height: calc(100vh - 15.6rem);
  overflow: auto;
  padding-bottom: 0.8rem;

  @media (hover: none) {
    width: var(100vw - 3.2rem);
  }

  .SearchAddressContent {
    &__address-info {
      padding: 0.8rem 0;
      cursor: pointer;
      background-color: var(--palette-gray-s0-l25);

      .InfoCard {
        &__content {
          display: flex;
          flex-direction: column-reverse;

          &__value {
            color: var(--palette-white);
          }
        }
      }

      &:hover {
        background-color: var(--palette-primary);
      }
    }

    &__empty {
      font-size: 1.6rem;
      padding: 1.6rem 0;
      padding-left: 1.2rem;
    }
  }
`;

export default SearchAddressStyled;
